import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { OnClickButton } from '../buttons/onclick/OnClickButton'
import { Stethoscope } from '../icons'
import { Title4, BodyLarge, BodyLargeMedium } from '../styles/Typography'
import { useTranslation } from 'react-i18next'
import { useWindowWidth } from '../../hooks/useWindowWidth'
import { isMobile, isTablet } from '../../utils/devices'
import { useEmitEvent } from '../../hooks/analytics/useEmitEvent'
import { TrackingEvents } from '@estercare/ester-shared'

export const HealthCareOptions = () => {
  const { t } = useTranslation()
  const width = useWindowWidth()
  const isMobileDevice = isTablet(width) || isMobile(width)
  const emitEvent = useEmitEvent()

  const healthCareOptions = [
    {
      title: t('employee.yourHealth.gynocologistOfficeTitle'),
      description: t('employee.yourHealth.gynocologistOfficeDescription'),
    },
    {
      title: t('employee.yourHealth.physicalClinicTitle'),
      description: t('employee.yourHealth.physicalClinicDescription'),
      link: {
        url: 'https://estercare.com/gynmottagning-torsplan',
        text: t('employee.yourHealth.learnMore'),
      },
    },
    {
      title: t('employee.yourHealth.digitalClinicTitle'),
      description: t('employee.yourHealth.digitalClinicDescription'),
      link: {
        url: 'https://estercare.com/sa-funkar-varden',
        text: t('employee.yourHealth.learnMore'),
      },
    },
  ]

  return (
    <>
      {!isMobileDevice && <BodyLargeMedium>{t('employee.yourHealth.needHealthCare')}</BodyLargeMedium>}
      <HealthCareContainer>
        {isMobileDevice && <BodyLargeMedium>{t('employee.yourHealth.needHealthCare')}</BodyLargeMedium>}
        {healthCareOptions.map((info, index) => (
          <InfoContainer key={index}>
            <TitleWrapper>
              <Circle>
                <Stethoscope size={24} key={`describe${index}`} color={theme.color.white} />
              </Circle>
              <StyledTitle4>{info.title}</StyledTitle4>
            </TitleWrapper>
            <BodyLarge>{info.description}</BodyLarge>
            {info.link && (
              <ButtonWrapper>
                <OnClickButton
                  secondary
                  buttonColor={theme.color.white}
                  onClick={() => {
                    emitEvent({
                      eventType: TrackingEvents.CLICK,
                      action: `link_button_to_${info.link.url}`,
                      options: {
                        metadata: {
                          button_text: info.link.text,
                        },
                      },
                    })
                    window.open(info.link.url, '_blank', 'noopener,noreferrer')
                  }}
                  text={info.link.text}
                />
              </ButtonWrapper>
            )}
          </InfoContainer>
        ))}
      </HealthCareContainer>
    </>
  )
}

const StyledTitle4 = styled(Title4)`
  word-break: break-word;
`
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.medium}px;
`
const ButtonWrapper = styled.div`
  max-width: 150px;
  margin-top: auto;
`
const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
`
const HealthCareContainer = styled.div`
  border-radius: ${theme.spacing.medium}px;
  display: flex;
  gap: ${theme.spacing.mediumLarge}px;
  margin-top: ${theme.spacing.mediumLarge}px;
  padding: ${theme.spacing.large}px;
  width: 100%;
  background-color: ${theme.color.plum};
  color: ${theme.color.white};
  align-items: stretch;
  @media screen and (max-width: ${theme.breakpoint.large}px) {
    flex-direction: column;
    margin-top: 0;
  }
`
const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.mediumLarge}px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: ${theme.spacing.medium}px;
  padding: ${theme.spacing.mediumLarge}px ${theme.spacing.medium}px;
  color: ${theme.color.white};
  width: 35%;
  @media screen and (max-width: ${theme.breakpoint.large}px) {
    width: 100%;
  }
`
